import { render, staticRenderFns } from "./Banks.vue?vue&type=template&id=1dbcb348&"
import script from "./Banks.vue?vue&type=script&lang=js&"
export * from "./Banks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports